import * as t from "io-ts";
export const unitT = t.union([
    t.literal("EUR-PL-QUARTER"),
    t.literal("EUR-PL-HALF"),
    t.literal("EUR-PL"),
    t.literal("UK-PL"),
    t.literal("FTL"),
    t.literal("UNIT"),
    t.literal("BB-LG"),
    t.literal("BB-XL"),
    t.literal("OTHER"),
]);
//# sourceMappingURL=cargo-unit.js.map